import script from "./quickMenu.vue?vue&type=script&setup=true&name=quickMenu&lang=js"
export * from "./quickMenu.vue?vue&type=script&setup=true&name=quickMenu&lang=js"

const __exports__ = script;

export default __exports__